import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../core/models/RouteHelper';
import MatchReport from './MatchReport';

interface OwnProps {}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(MatchReport);
